import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../common/constants";
import { PAGE_TITLE } from "../pages-meta";
import { type PageSummary, listPages } from "../services/Api";
import { Loader } from "../ui/Loader";

function formatWhen(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
}

export function Dashboard() {
  const [pages, setPages] = useState<PageSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listPages()
      .then((r) => setPages(r.data))
      .catch((e) => setError(e?.response?.data?.detail ?? "Failed to load pages."));
  }, []);

  return (
    <div className="page">
      <div className="page-title-row">
        <h1>Pages</h1>
      </div>

      {error && <p className="error-banner">{error}</p>}
      {pages === null && !error && <Loader />}

      {pages && (
        <div className="card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Page</th>
                <th>Status</th>
                <th>Last updated</th>
                <th aria-label="actions"></th>
              </tr>
            </thead>
            <tbody>
              {pages.map((page) => (
                <tr key={page.slug}>
                  <td className="cell-title">{PAGE_TITLE[page.slug] ?? page.slug}</td>
                  <td>
                    {page.has_unpublished_changes ? (
                      <span className="badge badge-draft">Unpublished changes</span>
                    ) : (
                      <span className="badge badge-published">Published</span>
                    )}
                  </td>
                  <td className="muted">{formatWhen(page.updated_at ?? page.published_at)}</td>
                  <td className="cell-actions">
                    <Link className="btn-ghost" to={ROUTES.PAGE_EDITOR(page.slug)}>
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
